export default __webpack_public_path__ + "static/media/factory__26.f8e18ca1.jpg";